/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getManyBaseMgmtShopOrderControllerShopOrder } from '../fn/shop/get-many-base-mgmt-shop-order-controller-shop-order';
import { GetManyBaseMgmtShopOrderControllerShopOrder$Params } from '../fn/shop/get-many-base-mgmt-shop-order-controller-shop-order';
import { getManyBaseShopOrderControllerShopOrder } from '../fn/shop/get-many-base-shop-order-controller-shop-order';
import { GetManyBaseShopOrderControllerShopOrder$Params } from '../fn/shop/get-many-base-shop-order-controller-shop-order';
import { GetManyShopOrderResponseDto } from '../models/get-many-shop-order-response-dto';
import { getOneBaseMgmtShopOrderControllerShopOrder } from '../fn/shop/get-one-base-mgmt-shop-order-controller-shop-order';
import { GetOneBaseMgmtShopOrderControllerShopOrder$Params } from '../fn/shop/get-one-base-mgmt-shop-order-controller-shop-order';
import { getOneBaseShopOrderControllerShopOrder } from '../fn/shop/get-one-base-shop-order-controller-shop-order';
import { GetOneBaseShopOrderControllerShopOrder$Params } from '../fn/shop/get-one-base-shop-order-controller-shop-order';
import { shopControllerCreateMemberOrder } from '../fn/shop/shop-controller-create-member-order';
import { ShopControllerCreateMemberOrder$Params } from '../fn/shop/shop-controller-create-member-order';
import { shopControllerCreateOrder } from '../fn/shop/shop-controller-create-order';
import { ShopControllerCreateOrder$Params } from '../fn/shop/shop-controller-create-order';
import { ShopOrder } from '../models/shop-order';
import { updateOneBaseMgmtShopOrderControllerShopOrder } from '../fn/shop/update-one-base-mgmt-shop-order-controller-shop-order';
import { UpdateOneBaseMgmtShopOrderControllerShopOrder$Params } from '../fn/shop/update-one-base-mgmt-shop-order-controller-shop-order';

@Injectable({ providedIn: 'root' })
export class ShopApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `shopControllerCreateOrder()` */
  static readonly ShopControllerCreateOrderPath = '/api/shop/order';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopControllerCreateOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopControllerCreateOrder$Response(params: ShopControllerCreateOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopOrder>> {
    const obs = shopControllerCreateOrder(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopControllerCreateOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopControllerCreateOrder(params: ShopControllerCreateOrder$Params, context?: HttpContext): Observable<ShopOrder> {
    const resp = this.shopControllerCreateOrder$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShopOrder>): ShopOrder => r.body)
    );
  }

  /** Path part for operation `shopControllerCreateMemberOrder()` */
  static readonly ShopControllerCreateMemberOrderPath = '/api/shop/{id}/order';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopControllerCreateMemberOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopControllerCreateMemberOrder$Response(params: ShopControllerCreateMemberOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopOrder>> {
    const obs = shopControllerCreateMemberOrder(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopControllerCreateMemberOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopControllerCreateMemberOrder(params: ShopControllerCreateMemberOrder$Params, context?: HttpContext): Observable<ShopOrder> {
    const resp = this.shopControllerCreateMemberOrder$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShopOrder>): ShopOrder => r.body)
    );
  }

  /** Path part for operation `getOneBaseShopOrderControllerShopOrder()` */
  static readonly GetOneBaseShopOrderControllerShopOrderPath = '/api/shop/{memberId}/order/{id}';

  /**
   * Retrieve a single ShopOrder.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseShopOrderControllerShopOrder()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseShopOrderControllerShopOrder$Response(params: GetOneBaseShopOrderControllerShopOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopOrder>> {
    const obs = getOneBaseShopOrderControllerShopOrder(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single ShopOrder.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseShopOrderControllerShopOrder$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseShopOrderControllerShopOrder(params: GetOneBaseShopOrderControllerShopOrder$Params, context?: HttpContext): Observable<ShopOrder> {
    const resp = this.getOneBaseShopOrderControllerShopOrder$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShopOrder>): ShopOrder => r.body)
    );
  }

  /** Path part for operation `getManyBaseShopOrderControllerShopOrder()` */
  static readonly GetManyBaseShopOrderControllerShopOrderPath = '/api/shop/{memberId}/order';

  /**
   * Retrieve multiple ShopOrders.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseShopOrderControllerShopOrder()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseShopOrderControllerShopOrder$Response(params: GetManyBaseShopOrderControllerShopOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyShopOrderResponseDto>> {
    const obs = getManyBaseShopOrderControllerShopOrder(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple ShopOrders.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseShopOrderControllerShopOrder$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseShopOrderControllerShopOrder(params: GetManyBaseShopOrderControllerShopOrder$Params, context?: HttpContext): Observable<GetManyShopOrderResponseDto> {
    const resp = this.getManyBaseShopOrderControllerShopOrder$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyShopOrderResponseDto>): GetManyShopOrderResponseDto => r.body)
    );
  }

  /** Path part for operation `getOneBaseMgmtShopOrderControllerShopOrder()` */
  static readonly GetOneBaseMgmtShopOrderControllerShopOrderPath = '/api/shop/mgmt-shop-orders/{id}';

  /**
   * Retrieve a single ShopOrder.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseMgmtShopOrderControllerShopOrder()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtShopOrderControllerShopOrder$Response(params: GetOneBaseMgmtShopOrderControllerShopOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopOrder>> {
    const obs = getOneBaseMgmtShopOrderControllerShopOrder(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single ShopOrder.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseMgmtShopOrderControllerShopOrder$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtShopOrderControllerShopOrder(params: GetOneBaseMgmtShopOrderControllerShopOrder$Params, context?: HttpContext): Observable<ShopOrder> {
    const resp = this.getOneBaseMgmtShopOrderControllerShopOrder$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShopOrder>): ShopOrder => r.body)
    );
  }

  /** Path part for operation `updateOneBaseMgmtShopOrderControllerShopOrder()` */
  static readonly UpdateOneBaseMgmtShopOrderControllerShopOrderPath = '/api/shop/mgmt-shop-orders/{id}';

  /**
   * Update a single ShopOrder.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOneBaseMgmtShopOrderControllerShopOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOneBaseMgmtShopOrderControllerShopOrder$Response(params: UpdateOneBaseMgmtShopOrderControllerShopOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopOrder>> {
    const obs = updateOneBaseMgmtShopOrderControllerShopOrder(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a single ShopOrder.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOneBaseMgmtShopOrderControllerShopOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOneBaseMgmtShopOrderControllerShopOrder(params: UpdateOneBaseMgmtShopOrderControllerShopOrder$Params, context?: HttpContext): Observable<ShopOrder> {
    const resp = this.updateOneBaseMgmtShopOrderControllerShopOrder$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShopOrder>): ShopOrder => r.body)
    );
  }

  /** Path part for operation `getManyBaseMgmtShopOrderControllerShopOrder()` */
  static readonly GetManyBaseMgmtShopOrderControllerShopOrderPath = '/api/shop/mgmt-shop-orders';

  /**
   * Retrieve multiple ShopOrders.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseMgmtShopOrderControllerShopOrder()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtShopOrderControllerShopOrder$Response(params?: GetManyBaseMgmtShopOrderControllerShopOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyShopOrderResponseDto>> {
    const obs = getManyBaseMgmtShopOrderControllerShopOrder(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple ShopOrders.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseMgmtShopOrderControllerShopOrder$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtShopOrderControllerShopOrder(params?: GetManyBaseMgmtShopOrderControllerShopOrder$Params, context?: HttpContext): Observable<GetManyShopOrderResponseDto> {
    const resp = this.getManyBaseMgmtShopOrderControllerShopOrder$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyShopOrderResponseDto>): GetManyShopOrderResponseDto => r.body)
    );
  }

}
